import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { CategoryStats } from '@/types/seeds';

interface CategoryStatsTableProps {
  categories: CategoryStats[];
}

export function CategoryStatsTable({ categories }: CategoryStatsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Category</TableHead>
            <TableHead>Seeds</TableHead>
            <TableHead>Sessions</TableHead>
            <TableHead>Completion Rate</TableHead>
            <TableHead>Avg Difficulty</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {categories.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-muted-foreground">
                No category data available.
              </TableCell>
            </TableRow>
          ) : (
            categories.map((c) => (
              <TableRow key={c.category}>
                <TableCell>
                  <Badge variant="outline">{c.category}</Badge>
                </TableCell>
                <TableCell>{c.seed_count}</TableCell>
                <TableCell>{c.session_count}</TableCell>
                <TableCell>{c.completion_rate}%</TableCell>
                <TableCell>{c.avg_difficulty_rating.toFixed(1)}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
